import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _awaitAsyncGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator.js";
import _wrapAsyncGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export var readableStreamtoIterable = function readableStreamtoIterable(readableStream) {
  return _defineProperty({}, Symbol.asyncIterator, _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var reader, _yield$_awaitAsyncGen, done, value;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reader = readableStream.getReader();
            _context.prev = 1;
          case 2:
            if (!true) {
              _context.next = 14;
              break;
            }
            _context.next = 5;
            return _awaitAsyncGenerator(reader.read());
          case 5:
            _yield$_awaitAsyncGen = _context.sent;
            done = _yield$_awaitAsyncGen.done;
            value = _yield$_awaitAsyncGen.value;
            if (!done) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return");
          case 10:
            _context.next = 12;
            return value;
          case 12:
            _context.next = 2;
            break;
          case 14:
            _context.prev = 14;
            reader.releaseLock();
            return _context.finish(14);
          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1,, 14, 17]]);
  })));
};
export var iterableToReadableStream = function iterableToReadableStream(asyncIterable) {
  var iterator = asyncIterable[Symbol.asyncIterator]();
  return new ReadableStream({
    pull: function pull(controller) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$iterator$next, done, value;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return iterator.next();
              case 2:
                _yield$iterator$next = _context2.sent;
                done = _yield$iterator$next.done;
                value = _yield$iterator$next.value;
                if (!done) {
                  _context2.next = 7;
                  break;
                }
                return _context2.abrupt("return", controller.close());
              case 7:
                controller.enqueue(value);
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  });
};